<template>
    <div class="stylists-archive-listing" v-if="!loading">
        <div id="news" class="section p-t-4 light-blue">
            <div class="_1440-wrap">
                <div v-if="!profiles.length">
                    <div id="no-stylist-posts-vue"><b>No stylist found</b></div>
                </div>
                <div v-if="profiles.length">
                    <div class="stylist-list-wrap">
                        
                            <div v-for="profile in profiles" class="stylist-block">
                                <a v-bind:href="'/'+profile_url_prefix+'/'+profile.profile_url" class="stylist-link-block w-inline-block" v-bind:title="profile.first_name+' '+profile.last_name">
                                    <div class="stylist-headshot-small-wrap">
                                        <img v-bind:src="profile.avatar.length ? profile.avatar : templateDirectory+'/images/logo-512-512.png'" alt="Ring My Stylist" class="stylist-headshot-small">
                                    </div>
                                    <div class="stylist-thumb-details" style="text-align:left">
                                        <div class="stylist-name-card">
                                            {{profile.first_name}} {{profile.last_name}}
                                        </div>
                                        <div v-if="profile.profession.length>0">
                                            <div class="stylist-title-small">
                                                <div v-for="(value, key) in profile.profession">
                                                    {{value.profession}} {{profile.profession.length-1 == key ? '' : ', '}}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="stylist-title-small">{{profile.profile.profession}}</div>
                                        </div>
                                        <div class="salon-name-small">{{profile.profile.city ? profile.profile.city.toUpperCase()+', ' : ''}}
                                        {{profile.profile.state.toUpperCase()}} {{profile.profile.zip}}</div>
                                    </div>
                                </a>
                            </div>
                        
                    </div>
                </div>
                <a href="#" class="btn-more w-button load-more-stylists" v-on:click="loadMoreStylists" v-if="loadMore" style="z-index:9999">Load More</a>
            </div>
        </div>
    </div>
    <div v-else style="height:250px;z-index:9999">
        <h2><b>Loading.....</b></h2>
    </div>
</template>

<script>
    import $ from 'jquery'
    import {eventBus} from "../main"


    export default {
        name: 'StylistsArchiveListing',
        data() {
            return {
                loading: true,
                templateDirectory: document.getElementById("template_directory").value,
                stylistsList: {},
                professions: [],
                profiles: [],
                total: 0,

                stylists_start_value: 0,
                all_stylists: 0,
                stylistsperpage: 30,
                loadperclick: 30,
                search: '',
                location: '',
                sort: '',
                state: '',
                city: '',
                profile_url_prefix: 'stylist-profile',

                mounted: false,
                loadMore: true
            }
        },
        props: {},
        created () {
            this.fetchArchiveListing();
            eventBus.$on('searchFetchStylists', (data) => {
                this.search = data[0];
                this.location = data[1];
                this.stylists_start_value=0;
                this.loadMoreStylists();
            });
        },

        mounted() {
            document.onreadystatechange = () => { 
                if (document.readyState == "complete") { 
                    //this.fetchArchiveListing();
                } 
            }
        },

        methods: {
            fetchArchiveListing() {
                //this.loading = true;
                var data = new FormData();
                data.append('action', 'get_stylist_profiles_list');

                this.$http.post(ajax_object.ajax_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            if(this.mounted==false) {
                                this.professions = response.data.professions
                            }

                            this.loadMore = true;
                            this.mounted = true;
                            eventBus.$emit('professionsToSearchComponent',this.professions)
                        }
                    });
            },

            loadMoreStylists() {
                this.stylists_start_value+=this.loadperclick;
                var data = new FormData();
                data.append('action', 'get_stylists');
                data.append('load_per_click', this.stylists_start_value);
                data.append('start_val', 0);
                data.append('sort', this.sort);
                data.append('search', this.search);
                data.append('location', this.location);
                data.append('state', this.state);
                data.append('city', this.city);
                data.append('vue', 'yes');

                this.$http.post(ajax_object.ajax_url,data)
                    .then(response => {
                        if(response.data == 'null') {
                            this.profiles = []
                            this.stylists_start_value = 0
                            this.loading = false;
                            this.loadMore = false;
                            return;
                        }

                        if(response.error == true){
                            alert('error');
                        }else{
                            if(this.mounted==false) {
                                this.professions = response.data.professions
                            }
                            this.profiles = response.data.profiles
                            this.total = response.data.total

                            if(typeof response.data.profile_url_prefix != 'undefined') {
                                this.profile_url_prefix = response.data.profile_url_prefix;
                            }

                            this.loadMore = true
                            if( this.profiles.length >= this.total ) {
                                this.loadMore = false
                            }
                            this.mounted = true;
                            this.loading = false;
                        }
                    });
            },
        }
    }
</script>
<style type="text/css">
    .stylist-headshot-small-wrap {
        position:relative;
        width:65px;
        height:65px;
        margin-right:15px;
        border-radius: 100%;
        overflow:hidden;
    }

    .stylist-headshot-small-wrap img.stylist-headshot-small {
        display:block;
        position:absolute;
        width:100%;
        height:auto;
        min-height:65px;
        top:0;
        left:0;
        margin:0 !important;
    }
</style>